import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import {
  MAX_CHARS_IN_ABOUT_SECTION,
  KeyCode,
} from '../../../../utils/constants';
import classNames from 'classnames';
import s from './ExpertDataAbout.scss';
import ExpertDataTitle from '../ExpertDataTitle/ExpertDataTitle';
import { Text, TextButton } from 'wix-style-react';
import { ServicesProvider } from '@wix/experts-common';

const mapStateToProps = ({}) => ({
  maxCharsInAbout: MAX_CHARS_IN_ABOUT_SECTION,
});
class ExpertDataAbout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isReadMoreClicked: false,
      readMoreAboutMe: false,
      readMoreMoreInfo: false,
    };
  }

  static propTypes = {
    t: PropTypes.func,
    about: PropTypes.string,
    additionalInfo: PropTypes.string,
    expertName: PropTypes.string,
    expertGuid: PropTypes.string,
    isMyProfile: PropTypes.bool,
  };

  static defaultProps = {
    isMyProfile: false,
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    if (
      !this.state.isReadMoreClicked &&
      this.getAbout(false).length > this.props.maxCharsInAbout
    ) {
      this.setState({ readMoreAboutMe: true });
    }
    if (
      !this.state.isReadMoreClicked &&
      this.getMoreInfo(false).length > this.props.maxCharsInAbout
    ) {
      this.setState({ readMoreMoreInfo: true });
    }
  }

  handleReadMoreClicked(isReadMoreClicked) {
    this.context.services.withBI(
      {
        evid: 148,
        typeid: 1,
        proGuid: this.props.expertGuid,
      },
      this.setState({ isReadMoreClicked }),
    );
  }

  getAbout = (shouldShorten = true) => {
    const { about, additionalInfo, maxCharsInAbout } = this.props;
    let aboutToShow = additionalInfo ? `${about}\n\n${additionalInfo}` : about;
    if (
      shouldShorten &&
      !this.state.isReadMoreClicked &&
      aboutToShow.length > maxCharsInAbout
    ) {
      aboutToShow = aboutToShow.substr(0, maxCharsInAbout) + '...';
    }
    return aboutToShow;
  };

  getMoreInfo = (shouldShorten = true) => {
    const { additionalInfo, maxCharsInAbout } = this.props;
    let additionalInfoToShow = additionalInfo;
    if (
      shouldShorten &&
      !this.state.isReadMoreClicked &&
      additionalInfo.length > maxCharsInAbout
    ) {
      additionalInfoToShow = additionalInfo.substr(0, maxCharsInAbout) + '...';
    }
    return additionalInfoToShow;
  };

  render() {
    const { t, about, expertName, isMyProfile } = this.props;
    const { isReadMoreClicked, readMoreAboutMe } = this.state;
    const { isInModal } = this.context.services;

    return (
      <div className={s.expertDataAbout}>
        <div className={s.title} data-hook="expert-data-about-title">
          <ExpertDataTitle
            title={t('client-expertview-aboutme-title')}
            tabName="about"
            showEditProfileLink={isMyProfile && !isInModal}
          />
        </div>
        <div className={classNames(s.content, s.blockedContent)}>
          <div className={classNames(s.contentSection, s.about, s.fullWidth)}>
            {about.length > 0 && (
              <div data-hook="about-section">
                <Text
                  tagName="div"
                  weight="bold"
                  size="medium"
                  className={s.subTitle}
                  dataHook="about-me-title"
                >
                  {t('client-expertview-aboutme-expert', { expertName })}
                </Text>
                <Text
                  tagName="div"
                  weight="thin"
                  size="medium"
                  className={s.text}
                  dataHook="about-me-text"
                >
                  {this.getAbout()}
                  {!isReadMoreClicked && readMoreAboutMe && (
                    <span>
                      &nbsp;
                      <a
                        className={s.toggleReadMore}
                        onClick={() => {
                          this.handleReadMoreClicked(true);
                        }}
                        onKeyUp={e => {
                          e.keyCode === KeyCode.Enter && e.target.click();
                        }}
                        data-hook="read-more-about"
                      >
                        <TextButton as="span" size="medium">
                          {t('client-expertview-aboutme-read')}
                        </TextButton>
                      </a>
                    </span>
                  )}
                </Text>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ExpertDataAbout.contextTypes = ServicesProvider.childContextTypes;
const ConnectedExpertDataAbout = connect(mapStateToProps, {})(ExpertDataAbout);
export default translate()(ConnectedExpertDataAbout);
